import React from "react";
import { FileText, Layers, Zap, FileCheck, Link, Download } from "lucide-react";
import { features } from "../data/mockData";

const iconMap = {
  FileText,
  Layers, 
  Zap,
  FileCheck,
  Link,
  Download
};

const FeaturesSection = () => {
  return (
    <section id="features" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Powerful Features for
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-pink-500">
              Document Automation
            </span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Everything you need to streamline your document generation process within Salesforce
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div 
                key={feature.id}
                className="group relative bg-gradient-to-br from-white to-slate-50 p-8 rounded-2xl border border-slate-200/50 hover:border-orange-200 transition-all duration-300 hover:shadow-lg hover:shadow-orange-100/50 hover:transform hover:scale-105"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br from-orange-100 to-pink-100 rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300">
                  <IconComponent className="text-orange-600 group-hover:text-orange-700 transition-colors duration-300" size={28} />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-slate-900 mb-4 group-hover:text-orange-700 transition-colors duration-300">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {feature.description}
                </p>

                {/* Hover Effect Border */}
                <div className="absolute inset-0 border-2 border-transparent group-hover:border-orange-200 rounded-2xl transition-colors duration-300"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;